import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Select,
  ModalFooter,
  Button,
} from "@chakra-ui/react";
import CampaignTypes from "./CampaignTypes";

const AddCampaignModal = ({
  isOpen,
  onClose,
  campaignType,
  campaignMedium,
  campaignCategory,
  handleCampaignTypeChange,
  handleCampaignMediumChange,
  setCampaignCategory,
  categories,
  createCampaign,
  resetData,
}) => {
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create New Campaign</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Type</FormLabel>
            <Select
              placeholder="Select type"
              value={campaignType}
              onChange={handleCampaignTypeChange}
            >
              {CampaignTypes.map((ct, index) => (
                <option key={index} value={ct.id}>
                  {ct.name}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>Medium</FormLabel>
            <Select
              placeholder="Select medium"
              value={campaignMedium}
              onChange={handleCampaignMediumChange}
              isDisabled={!campaignType}
            >
              <option value="Email">Email</option>
              <option value="SMS">Text Message</option>
              {campaignType === "reminder" && (
                <option value="Phone">Phone</option>
              )}
            </Select>
          </FormControl>
          <FormControl mt={4} isDisabled={
            !campaignMedium || 
            campaignMedium === "Phone" || 
            (campaignMedium === "SMS" && campaignType !== 'reminder')}>
            <FormLabel>Category</FormLabel>
            <Select
              placeholder="Select category"
              value={campaignCategory}
              onChange={(e) => setCampaignCategory(e.target.value)}
            >
              {campaignMedium === "SMS" && campaignType == "reminder"? ['Reminder', 'Confirmation'].map((category,index)=>(
              <option key={index} value={category}>
                {category}
              </option>
              )) : categories
                ?.filter((category) =>
                  new RegExp(`${campaignType}|build`, "i").test(
                    category.name.toLowerCase()
                  )
                )
                .map((category, index) => (
                  <option key={index} value={category.id}>
                    {category.name}
                  </option>
                ))}
            </Select>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            onClick={() => {
              onClose();
              resetData();
            }}
          >
            Cancel
          </Button>
          <Button
            marginLeft="10px"
            colorScheme="blue"
            mr={3}
            onClick={createCampaign}
            isDisabled={
              !(
                campaignType &&
                campaignMedium &&
                (
                  (campaignMedium === 'SMS' && ((campaignType === 'reminder' && campaignCategory) || campaignType !== 'reminder')) ||
                  (campaignMedium === 'Email' && campaignCategory) ||
                  (campaignMedium === "Phone"))
              )
            }
          >
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddCampaignModal;
